// extracted by mini-css-extract-plugin
export default {"inputRotator":"styles_inputRotator__31LD7"};